import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'types',
        component: () => import('../views/Types')
    },
    {
        path: '/subtypes',
        name: 'subtypes',
        component: () => import('../views/SubTypes')
    },
    {
        path: '/contents',
        name: 'contents',
        component: () => import('../views/Contents')
    },
    {
        path: '/content',
        name: 'content',
        component: () => import('../views/Content')
    },
]

export default new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
